import { Injectable } from '@angular/core';
import { environment } from '@rocksoft/environment';
import { HubService } from './hub.service';

@Injectable()
export class LocationsMdmHubService extends HubService {
  constructor() {
    super(`${environment.locations.api}/hubs/locations-mdm`);
  }
}
